import { Gondor } from "../Gondor";

const ACTIONS = {
  LANDING: "/landing/",
  LANDING_ITEM: "/landing/{id}/",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.LANDING, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.LANDING_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.LANDING, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.LANDING_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.LANDING_ITEM.replace("{id}", id));
}
